<template>
  <v-container fluid>
    <v-row>
      <v-col md="6" cols="12">
        <div class="conOfHeader">
          <div class="headerOfPage">Teams</div>
        </div>
      </v-col>
      <v-col md="6" cols="12">
        <div class="conOfHeader text-right">
          <div class="btnAdd">
            <v-btn class="btnAddPrimary" @click="dialogProject = true">
              <v-icon>mdi-plus</v-icon>
              Create New
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="listData && listData.length > 0">
      <v-col cols="12">
        <section class="conOfProjects">
          <div class="conOfTable">
            <v-data-table
              :headers="headers"
              :items="listData"
              :items-per-page="10"
              hide-default-footer
            >
              <template v-slot:[`item.actions`]="{ item }">
                <v-menu bottom :left="true" :offset-y="true">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn dark icon v-bind="attrs" v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="editItem(item)">
                      <v-list-item-title class="statusTxt">
                        Edit
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="deleteItem(item)">
                      <v-list-item-title class="statusTxt">
                        Delete
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
              <template v-slot:[`item.created_at`]="{ item }">
                <div>{{ item.created_at | formatDate }}</div>
              </template>
              <template v-slot:[`item.team_users`]="{ item }">
                <router-link
                  :to="{
                    name: 'settingTeamsMembers',
                    params: { id: item.id },
                  }"
                >
                  {{ item.team_users.length }}
                </router-link>
                <!-- <div>{{ item.team_users }}</div> -->
              </template>
            </v-data-table>
          </div>
        </section>
        <div
          class="conOfPagination pr-5 pt-5"
          v-if="pagination.total > pagination.per_page"
        >
          <v-pagination
            :total-visible="7"
            v-model="pagination.current_page"
            :length="pagination.last_page"
            @input="goToPage(pagination.current_page)"
          ></v-pagination>
        </div>
      </v-col>
    </v-row>
    <div class="loaderContainer" v-else-if="isLoading">
      <v-progress-circular
        :size="120"
        :width="4"
        indeterminate
        color="primary"
      ></v-progress-circular>
    </div>
    <v-row v-else>
      <v-col cols="12" class="mt-7">
        <EmptyState />
      </v-col>
    </v-row>
    <v-snackbar
      v-model="successSnackbar"
      color="success"
      shaped
      absolute
      top
      right
      :timeout="timeout"
    >
      {{ successMessage }}
    </v-snackbar>
    <v-snackbar
      v-model="errorSnackbar"
      color="red"
      shaped
      top
      right
      :timeout="timeout"
    >
      {{ errorMessage }}
    </v-snackbar>
    <v-dialog scrollable v-model="dialogProject" max-width="500" persistent>
      <v-card class="conOfPopup">
        <v-card-title>
          <span class="text-h5 callbacks modalTitle">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text class="conFormSubmit scrollbar">
          <v-container>
            <v-row>
              <v-col cols="12">
                <label class="eachLabel">Team Name</label>
                <v-text-field
                  class="eachInput"
                  placeholder="Team Name"
                  outlined
                  solo
                  hide-details="auto"
                  v-model="formItem.name"
                  required
                  :error-messages="nameErrors"
                  @input="$v.formItem.name.$touch()"
                  @blur="$v.formItem.name.$touch()"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <label class="eachLabel">Team Leader</label>
                <v-autocomplete
                  outlined
                  v-model="formItem.user_id"
                  item-text="name"
                  item-value="id"
                  :items="listTeamLeaders"
                  placeholder="Team Leader"
                  hide-details="auto"
                  :menu-props="{ bottom: true, offsetY: true }"
                  append-icon="mdi-chevron-down"
                  required
                  :error-messages="user_idErrors"
                  @input="$v.formItem.user_id.$touch()"
                  @blur="$v.formItem.user_id.$touch()"
                  :disabled="isLoadingUsersList"
                  :loading="isLoadingUsersList"
                >
                  <template slot="selection" slot-scope="data">
                    {{ data.item.name }}
                    <span class="leaderSpan">
                      {{ data.item.team_leader ? "Leader" : "" }}
                    </span>
                  </template>
                  <template slot="item" slot-scope="data">
                    {{ data.item.name }}
                    <span class="leaderSpan">
                      {{ data.item.team_leader ? "Leader" : "" }}
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="pb-10">
          <v-spacer></v-spacer>
          <v-btn class="btnCancel" tile @click="closeProjectModal">
            Cancel
          </v-btn>
          <v-btn
            class="btnPrimaryOrg"
            @click="saveItem"
            :disabled="isLoadingSave"
            :loading="isLoadingSave"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete" max-width="400px">
      <v-card class="conConfirmPopup">
        <v-card-title>
          <span class="text-h5 modalTitle">Are you sure</span>
        </v-card-title>
        <v-card-text class="textConfirm"
          >Are you sure you want to delete this item?</v-card-text
        >
        <v-card-actions class="pb-7">
          <v-spacer></v-spacer>
          <v-btn class="btnCancel" tile @click="closeDelete">Cancel</v-btn>
          <v-btn
            class="btnPrimaryOrg"
            tile
            @click="deleteItemConfirm"
            :disabled="isLoadingDelete"
            :loading="isLoadingDelete"
            >Delete</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { ApiService } from "@/modules/shared/services/api";
let apiServices = new ApiService();
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import EmptyState from "@/modules/shared/components/emptystate";
import { mapGetters } from "vuex";
export default {
  mixins: [validationMixin],
  validations() {
    const validations = {
      formItem: {
        name: { required },
        user_id: { required },
      },
    };
    // if (this.requireOfIndication) {
    //   validations.formItem.indication_id = {
    //     required,
    //   };
    // }
    return validations;
  },
  data: () => ({
    successSnackbar: false,
    errorSnackbar: false,
    timeout: 3000,
    dialogProject: false,
    dialogDelete: false,
    isLoadingSave: false,
    isLoadingUsersList: false,
    isLoadingDelete: false,
    isLoading: false,
    editedIndex: -1,
    pagination: {
      current_page: 1,
    },
    formItem: {},
    defaultItem: {},
    listTeamLeaders: [],
    headers: [
      {
        text: "NAME",
        align: "start",
        value: "name",
        sortable: false,
      },
      { text: "TEAMLEADER", value: "team_leader.name" },
      { text: "MEMBERS", value: "team_users" },
      { text: "UPDATED DATE", value: "created_at" },
      { text: "", value: "actions", sortable: false, align: "right" },
    ],
    listData: [],
  }),
  methods: {
    editItem(item) {
      this.editedIndex = item.id;
      let editFormItem = {
        name: item.name,
        user_id: item.team_leader.id,
      };
      this.formItem = editFormItem;
      this.dialogProject = true;
    },
    deleteItem(item) {
      this.editedIndex = item.id;
      // this.editedItem = item;
      // this.formItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.isLoadingDelete = true;
      apiServices.delete(`teams/${this.editedIndex}`).then((res) => {
        if (res) {
          this.pagination.current_page = 1;
          this.getListData(this.pagination.current_page);
          this.getUsersList();
          this.isLoadingDelete = false;
          this.closeDelete();
        } else {
          this.isLoadingDelete = false;
          this.closeDelete();
        }
      });
    },
    itemEdited() {
      this.$v.$touch();
      if (this.$v.$error) return;
      this.isLoadingSave = true;
      this.formItem["user_id"] = this.formItem.user_id.toString();

      apiServices
        .update(this.editedIndex, "teams", this.formItem)
        .then((res) => {
          if (res) {
            this.successMessage = res.message || "Successful";
            this.successSnackbar = true;

            this.pagination.current_page = 1;
            this.getListData(this.pagination.current_page);
            this.getUsersList();
            this.isLoadingSave = false;
            this.closeProjectModal();
          } else {
            this.isLoadingSave = false;
            let errors = Object.values(this.apiMessage)[0];
            errors.forEach((err) => {
              this.errorMessage = err;
            });
            this.errorSnackbar = true;
          }
        });
    },
    itemAddNew() {
      this.$v.$touch();
      if (this.$v.$error) return;
      this.isLoadingSave = true;
      this.formItem["user_id"] = this.formItem.user_id.toString();
      apiServices.post("teams", this.formItem).then((res) => {
        if (res) {
          this.successMessage = res.message || "Successful";
          this.successSnackbar = true;

          this.pagination.current_page = 1;
          this.getListData(this.pagination.current_page);
          this.getUsersList();
          this.isLoadingSave = false;
          this.closeProjectModal();
        } else {
          this.isLoadingSave = false;
          let errors = Object.values(this.apiMessage)[0];
          errors.forEach((err) => {
            this.errorMessage = err;
          });
          this.errorSnackbar = true;
        }
      });
    },
    saveItem() {
      if (this.editedIndex > -1) {
        this.itemEdited();
      } else {
        this.itemAddNew();
      }
    },
    closeProjectModal() {
      this.editedIndex = -1;
      this.dialogProject = false;
      setTimeout(() => {
        this.$nextTick(() => {
          this.$v.$reset();
          this.formItem = Object.assign({}, this.defaultItem);
        });
      }, 100);
    },
    closeDelete() {
      this.dialogDelete = false;
      this.editedIndex = -1;

      setTimeout(() => {
        this.$nextTick(() => {
          this.$v.$reset();
          this.formItem = Object.assign({}, this.defaultItem);
        });
      }, 100);
    },
    goToPage(page) {
      this.getListData(page);
      window.scrollTo(0, 0);
    },
    getListData(page) {
      this.listData = [];
      this.isLoading = true;
      apiServices.get(`teams?per_page=7&page=${page}`).then((res) => {
        if (res) {
          this.listData = res.data;
          this.pagination = res.meta;
          this.isLoading = false;
        } else this.isLoading = false;
      });
    },
    getUsersList() {
      this.listTeamLeaders = [];
      this.isLoadingUsersList = true;
      apiServices.get(`team/users`).then((res) => {
        if (res) {
          this.listTeamLeaders = res.data;
          this.isLoadingUsersList = false;
        } else this.isLoadingUsersList = false;
      });
    },
  },
  components: { EmptyState },
  computed: {
    ...mapGetters(["apiMessage"]),
    formTitle() {
      return this.editedIndex === -1 ? "Add New Team" : "Edit Team";
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.formItem.name.$dirty) return errors;
      !this.$v.formItem.name.required && errors.push("Team Name Is Required.");
      return errors;
    },
    user_idErrors() {
      const errors = [];
      if (!this.$v.formItem.user_id.$dirty) return errors;
      !this.$v.formItem.user_id.required &&
        errors.push("Team Leader Is Required.");
      return errors;
    },
  },
  created() {
    this.getListData(this.pagination.current_page);
    this.getUsersList();
  },
  watch: {
    dialogProject(val) {
      val || this.closeProjectModal();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./_teams.scss";
</style>
